export default __webpack_public_path__ + "static/media/alphonse.75df0a98.png";